export const TABLE_DATA_LOADING = "TABLE_DATA_LOADING";
export const TABLE_DATA_FETCH_SUCCESS = "TABLE_DATA_FETCH_SUCCESS";
export const TABLE_DATA_FETCH_ERROR = "TABLE_DATA_FETCH_ERROR";
export const SET_DT_REDUCER = "SET_DT_REDUCER";
export const TABLE_DATA_RESET = "TABLE_DATA_RESET";
